import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import type { OrchestratedQuote } from '@b-stock/fe-core/bstock-next/queries'
import {
  FormattedMessage,
  Modal,
  SpinnerDots,
} from '@b-stock/fe-core/bstock-react'
import { Breakpoints, pxToRem } from '@b-stock/fe-core/design-system'

import type { ParcelQuote } from './types'
import { useParcelRateFlow } from './useParcelRateFlow'

const ModalBody = styled.div`
  min-width: ${pxToRem(600)};

  @media ${Breakpoints.max.medium} {
    min-width: unset;
  }
`

type ParcelChangeCarrierModalProps = {
  quoteSet: ParcelQuote[] | undefined
  currentQuote: OrchestratedQuote | null | undefined
  isQuoteSetLoading: boolean
  isQuoteSetError: boolean
  isCarrierChangePending: boolean
  onSelectRate: (quoteId: string) => Promise<void>
  currency: string
  onClose: () => void
}

export const ParcelChangeCarrierModal = ({
  quoteSet,
  currentQuote,
  isQuoteSetLoading,
  isQuoteSetError,
  isCarrierChangePending,
  onSelectRate,
  currency,
  onClose,
}: ParcelChangeCarrierModalProps) => {
  const { formatMessage } = useIntl()
  const { parcelRateList } = useParcelRateFlow({
    showParcelRates: true,
    quoteSet,
    selectedQuote: currentQuote,
    isQuoteSetLoading,
    isQuoteSetError,
    isCarrierChangePending,
    setSelectedCarrier: onSelectRate,
    currency,
    selectErrorMessage: formatMessage({ id: 'ChangeCarrierModal.error' }),
  })

  return (
    <Modal closeModal={isCarrierChangePending ? () => undefined : onClose}>
      <Modal.Header>
        <FormattedMessage id="ChangeCarrierModal.title" />
      </Modal.Header>
      <Modal.Content>
        <ModalBody>
          {isQuoteSetLoading && !quoteSet ? (
            <div data-testid="parcel-rates-loading">
              <SpinnerDots />
            </div>
          ) : (
            parcelRateList
          )}
        </ModalBody>
      </Modal.Content>
    </Modal>
  )
}
